import React, { useCallback, useMemo, useState } from 'react'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import OfferCarouselLookingForSomethingElse from 'home/components/LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from 'home/components/LookingForSomethingElse/constants'
import useOfferList from 'hooks/Offers/useOfferList'
import { usePlaceByName } from 'hooks/usePlace'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import OfferCarouselHeader from 'home/components/OfferCarousels/common/OfferCarouselHeader'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OfferCardCarouselSectionFilters from 'components/Common/OfferCardCarousel/OfferCardCarouselSectionFilters'

const Container = styled(Group)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

interface Props extends App.ContentfulWebPageOfferCarousel {}

function ContentfulOfferCarousel(props: Props) {
  const { holidayTypes, title, campaigns, offersToShow, offerTypes, viewAllLink, destination } = props
  const destinationId = usePlaceByName(destination)?.id
  const [selectedFilter, setSelectedFilter] = useState<string>()
  const offerList = useOfferList({
    offerTypes,
    holidayTypes: selectedFilter ? [selectedFilter] : undefined,
    destinationId,
    sortBy: 'home',
    campaigns,
    limit: offersToShow,
  })

  const toggleFilter = useCallback((name: string) => {
    setSelectedFilter(selectedFilter === name ? undefined : name)
  }, [selectedFilter])

  const holidayTypeOptions = useMemo(() => holidayTypes.map(type => ({
    value: type,
    label: type,
  })), [holidayTypes])

  return <Container direction="vertical" gap={16}>
    <LayoutContainer>
      <VerticalSpacer gap={20}>
        <OfferCarouselHeader allTo={viewAllLink}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </OfferCarouselHeader>
        {holidayTypeOptions.length > 0 && <OfferCardCarouselSectionFilters
          options={holidayTypeOptions}
          value={selectedFilter}
          onChange={toggleFilter}
        />}
      </VerticalSpacer>
    </LayoutContainer>
    <OfferListCarousel overrideOfferList={offerList}>
      <OfferCarouselLookingForSomethingElse to={LOOKING_FOR_SOMETHING_ELSE_CONTENT.hotels.to} />
    </OfferListCarousel>
  </Container>
}

export default ContentfulOfferCarousel
